export default "__VITE_ASSET__Cpwej$48__"